const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')

const maping = () => import(/* webpackPrefetch: true */ '@/views/private/monitoring/maping/index.vue')
const attendance_monitoring = () => import(/* webpackPrefetch: true */ '@/views/private/monitoring/attendance/index.vue')
const permission = () => import(/* webpackPrefetch: true */ '@/views/private/monitoring/permission/index.vue')

const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')

const unit = () => import(/* webpackPrefetch: true */ '@/views/private/unit/index.vue')

const officer = () => import(/* webpackPrefetch: true */ '@/views/private/officer/index.vue')
const officer_detail = () => import(/* webpackPrefetch: true */ '@/views/private/officer/_id.vue')

const attendance = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/index.vue')
const attendance_history = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/history/_id.vue')
const attendance_rekap = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/rekap/index.vue')
const attendance_late = () => import(/* webpackPrefetch: true */ '@/views/private/attendance/late/index.vue')

const overtime = () => import(/* webpackPrefetch: true */ '@/views/private/overtime/index.vue')
const overtime_history = () => import(/* webpackPrefetch: true */ '@/views/private/overtime/history/index.vue')

const salary = () => import(/* webpackPrefetch: true */ '@/views/private/salary/index.vue')
const salary_history = () => import(/* webpackPrefetch: true */ '@/views/private/salary/history/_id.vue')
const salary_month = () => import(/* webpackPrefetch: true */ '@/views/private/salary/month/index.vue')

const licensing = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/index.vue')
const licensing_holiday = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/holiday/index.vue')
const licensing_history = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/history/_id.vue')
const licensing_permission = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/permission/index.vue')
const licensing_submission = () => import(/* webpackPrefetch: true */ '@/views/private/licensing/submission/index.vue')

const report = () => import(/* webpackPrefetch: true */ '@/views/private/report/index.vue')
const announcement = () => import(/* webpackPrefetch: true */ '@/views/private/announcement/index.vue')
const audit = () => import(/* webpackPrefetch: true */ '@/views/private/audit/index.vue')
const setting = () => import(/* webpackPrefetch: true */ '@/views/private/setting/index.vue')

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: dashboard,
    meta: {
      title: "Dashboard"
    }
  },
  {
    path: "/profile",
    name: "Profil",
    component: profile,
    meta: {
      title: "Profil"
    }
  },
  {
    path: "/maping",
    name: "Maping",
    component: maping,
    meta: {
      title: "Maping"
    }
  },
  {
    path: "/attendance_monitoring",
    name: "Pegawai Presensi",
    component: attendance_monitoring,
    meta: {
      title: "Pegawai Presensi"
    }
  },
  {
    path: "/permission",
    name: "Pegawai Ijin",
    component: permission,
    meta: {
      title: "Pegawai Ijin"
    }
  },
  {
    path: "/unit",
    name: "Unit",
    component: unit,
    meta: {
      title: "Unit"
    }
  },
  {
    path: "/officer",
    name: "Pegawai",
    component: officer,
    meta: {
      title: "Pegawai"
    }
  },
  {
    path: "/officer/:id",
    name: "Detail Pegawai",
    component: officer_detail,
    meta: {
      title: "Detail Pegawai"
    }
  },
  {
    path: "/attendance",
    name: "Data Presensi",
    component: attendance,
    meta: {
      title: "Data Presensi"
    }
  },
  {
    path: "/attendance/history/:id",
    name: "Riwayat Presensi",
    component: attendance_history,
    meta: {
      title: "Riwayat Presensi"
    }
  },
  {
    path: "/attendance/rekap",
    name: "Rekap Presensi",
    component: attendance_rekap,
    meta: {
      title: "Rekap Presensi"
    }
  },
  {
    path: "/attendance/late",
    name: "Keterlambatan",
    component: attendance_late,
    meta: {
      title: "Keterlambatan"
    }
  },
  {
    path: "/overtime",
    name: "Data Lembur",
    component: overtime,
    meta: {
      title: "Data Lembur"
    }
  },
  {
    path: "/overtime/history",
    name: "Riwayat Lembur",
    component: overtime_history,
    meta: {
      title: "Riwayat Lembur"
    }
  },
  {
    path: "/salary",
    name: "Gaji Sekarang",
    component: salary,
    meta: {
      title: "Gaji Sekarang"
    }
  },
  {
    path: "/salary/history/:id",
    name: "Riwayat Gaji",
    component: salary_history,
    meta: {
      title: "Riwayat Gaji"
    }
  },
  {
    path: "/salary/month",
    name: "Gaji Bulanan",
    component: salary_month,
    meta: {
      title: "Gaji Bulanan"
    }
  },
  {
    path: "/licensing",
    name: "Perijinan",
    component: licensing,
    meta: {
      title: "Perijinan"
    }
  },
  {
    path: "/licensing/holiday",
    name: "Data Sisa Ijin",
    component: licensing_holiday,
    meta: {
      title: "Data Sisa Ijin"
    }
  },
  {
    path: "/licensing/history/:id",
    name: "Riwayat Ijin",
    component: licensing_history,
    meta: {
      title: "Riwayat Ijin"
    }
  },
  {
    path: "/licensing/permission",
    name: "Riwayat Ijin",
    component: licensing_permission,
    meta: {
      title: "Riwayat Ijin"
    }
  },
  {
    path: "/licensing/submission",
    name: "Ajuan Ijin",
    component: licensing_submission,
    meta: {
      title: "Ajuan Ijin"
    }
  },
  {
    path: "/report",
    name: "Laporan Pegawai",
    component: report,
    meta: {
      title: "Laporan Pegawai"
    }
  },
  {
    path: "/announcement",
    name: "Pengumuman",
    component: announcement,
    meta: {
      title: "Pengumuman"
    }
  },
  {
    path: "/audit",
    name: "Audit Trail",
    component: audit,
    meta: {
      title: "Audit Trail"
    }
  },
  {
    path: "/setting",
    name: "Konfigurasi",
    component: setting,
    meta: {
      title: "Konfigurasi"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})